import { Pipe, PipeTransform } from '@angular/core';



@Pipe({ name: 'euro' })
export class EuroPipe implements PipeTransform {
   transform(value: number | any): string {
      let result = '';

      if (value !== null && value !== undefined && !isNaN(Number(value))) {
         let parsedValue = typeof value === 'string' ? parseFloat(value) : Number(value);
         const parts = parsedValue.toString().split('.');
         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
         result = parts.join(',') + ' €';
      } else {
         result = '0 €';
      }

      return result;
   }
}

